import { render, staticRenderFns } from "./DataViewSidebarInstitutions.vue?vue&type=template&id=e830ede4&scoped=true"
import script from "./DataViewSidebarInstitutions.vue?vue&type=script&lang=js"
export * from "./DataViewSidebarInstitutions.vue?vue&type=script&lang=js"
import style0 from "./DataViewSidebarInstitutions.vue?vue&type=style&index=0&id=e830ede4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e830ede4",
  null
  
)

export default component.exports